import React, { useCallback, useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { useHistory } from 'react-router-dom';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import {
	IAndroidWatchesFormContext,
	AndroidWatchesFormContext,
} from '../../androidWatchesFormState/androidWatchesFormContext';
import { assignRestaurantAndroidWatchesMessages } from 'backend/watches';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, dataForSubmit, typeOfModalWindow } =
		useContext<IAndroidWatchesFormContext>(AndroidWatchesFormContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleRedirect = useCallback(() => {
		history.push('/clients/restaurants');
	}, [history]);

	const handleSubmitWatchesInfo = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await assignRestaurantAndroidWatchesMessages({
					restaurantID: convertedData.restaurantID,
					data: convertedData.data,
				});
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={handleRedirect}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && (
				<ModalToConfirm
					onConsentEvent={handleSubmitWatchesInfo}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="saveInfo"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorWhileSaving" />
			)}
		</div>
	);
};
